import { create } from 'zustand';

interface TimeoffOverlapData {
  assignmentId: number;
  userName?: string;
  projectName?: string;
}

interface TimeoffOverlapStore {
  data: TimeoffOverlapData | null;
  open: (data: TimeoffOverlapData) => void;
  close: () => void;
}

export const useTimeoffOverlapStore = create<TimeoffOverlapStore>(set => ({
  data: null,
  open: (data: TimeoffOverlapData) => set({ data }),
  close: () => set({ data: null }),
}));
